import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

export const Breadcrumbs = ({ items, light = false }) => (
  <nav aria-label="Breadcrumb" data-testid="breadcrumbs" className={`flex flex-wrap items-center gap-1.5 text-xs uppercase tracking-[0.14em] ${light ? "text-[var(--stone)]" : "text-[var(--muted)]"}`}>
    <Link to="/" className="hover:text-[var(--terracotta)] transition-colors">Home</Link>
    {items.map((it, i) => (
      <span key={it.to || i} className="flex items-center gap-1.5">
        <ChevronRight size={12} className="opacity-60" />
        {i === items.length - 1 || !it.to ? (
          <span aria-current="page" className={light ? "text-[var(--cream)]" : "text-[var(--ink)]"}>{it.label}</span>
        ) : (
          <Link to={it.to} className="hover:text-[var(--terracotta)] transition-colors">{it.label}</Link>
        )}
      </span>
    ))}
  </nav>
);
